const currencies = [
  'COP',
  'ARS',
  'BRL',
  'CLP',
  'EUR',
  'MXN',
  'PEN',
  'USD',
];

export default currencies;
